module.exports = __webpack_public_path__ + "static/media/2013.VEE.Jo.VMLiveMigration.8698eaf4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/2013.VEE.Jo.VMLiveMigration.pdf
// module id = 72
// module chunks = 0